import { useCallback, useMemo } from "react";
import { useForm } from "react-hook-form";
import { FormValues, StepType } from "./types";
import useAppContext from "./useAppContext";

interface UseFormStepOptions {
  next: StepType;
}

const useFormStep = ({ next }: UseFormStepOptions) => {
  const { dispatch, state } = useAppContext();
  const form = useForm<FormValues>({ defaultValues: state.form });

  const onSubmit = useCallback(
    (value: FormValues) => {
      dispatch({ type: "MERGE_FORM", value });
      dispatch({ type: "ADD_STEP", step: next });
    },
    [dispatch, next],
  );

  const handleBack = useCallback(() => {
    dispatch({ type: "POP_STEP" });
  }, [dispatch]);

  return useMemo(
    () => ({
      handleSubmit: form.handleSubmit(onSubmit),
      syntheticSubmit: () => onSubmit(form.getValues()),
      form,
      handleBack,
    }),
    [form, onSubmit, handleBack],
  );
};

export default useFormStep;
